<template>
    <div class="billOperationRecord public_Spacing reconciliation-detail-page">
        <!-- 返回箭头 -->
        <div class="rowBox reconciliation-back-card" @click="handleClick"><i class="el-icon-arrow-left" style="font-size: 20px;margin-left: 10px;"
                ></i><span class="reconciliation-back-text">返回账户列表</span></div>
        <div class="pulbic_oparetionBlock reconciliation-detail-filter-card" style="margin-bottom: 12px;">
            <div class="reconciliation-detail-head">
                <div>
                    <div class="reconciliation-detail-title">对账筛选</div>
                    <div class="reconciliation-detail-desc">选择月份、厂家和账户，查看账户对账明细</div>
                </div>
            </div>
            <div class="public_criteriaRange reconciliation-detail-filter-row">
                <span class="pulic_operatArea_now pulic_cursor reconciliation-month-tab" :class="dateNowMonthActive ? 'public_dateActive' : ''"
                    @click="sameMonth">当月</span>
                <span class="public_operatArea_yesterday pulic_cursor reconciliation-month-tab"
                    :class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
                <div class="public_operatArea_timePicker pulic_cursor reconciliation-month-picker">
                    <el-date-picker v-model="ORMTB801CA05" type="month" placeholder="选择月份" format="yyyy-MM"
                        value-format="yyyy-MM" @change="handleMonthChange">
                    </el-date-picker>
                </div>
                <div class="public_oparetionBlock_Menu reconciliation-detail-field">
                    <el-select class="public_optionSty dropDown_Define" v-model="ORMTB803ID" filterable
                        placeholder="请选择" @change="factoryIdchange">
                        <el-option v-for="item in factoryList" :key="item.ORMTB803ID" :label="item.ORMTB803CA01"
                            :value="item.ORMTB803ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu reconciliation-detail-field">
                    <el-select class="public_optionSty dropDown_Define" v-model="ORMTB804ID" placeholder="请选择"
                        filterable @change="accountChange">
                        <el-option v-for="item in accList" :key="item.ORMTB804ID" :label="item.ORMTB804CA01"
                            :value="item.ORMTB804ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="top_btn reconciliation-query-btn">
                    <el-button type="primary" @click="queryClick">查询</el-button>
                </div>
            </div>
            <div class="public_operatArea reconciliation-summary-row">
                <div class="public_operatArea_content reconciliation-summary-cards">
                    <div class="content_box reconciliation-summary-card">
                        月初余额:{{ firstSum }}
                    </div>
                    <div class="content_box reconciliation-summary-card reconciliation-summary-card-green" style="color:rgb(103, 198, 104)">
                        对账时间:{{ timeframe }}
                    </div>
                </div>
                <div class="public_operatBtn reconciliation-detail-actions">
                    <el-button type="primary" @click="handleRecharge">充值</el-button>
                    <el-button type="primary" @click="handleAdjust">调总账</el-button>
                    <el-button type="success" @click="exports">导出</el-button>
                </div>
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container reconciliation-detail-table-card">
            <div class="reconciliation-detail-table-head">
                <div class="reconciliation-detail-title">对账明细</div>
                <div class="reconciliation-detail-desc">查看销售、购进、充值、调总账和当前金额汇总</div>
            </div>
            <el-table tooltip-effect="dark" :data="tableData" show-summary :summary-method="getSummaries"
                style="width: 100%;" height="550px" :default-sort="{ prop: 'waterNum', order: 'descending' }"
                :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column prop="ORMTB801CA05" label="日期"></el-table-column>
                <el-table-column prop="ORMTB801CA06" label="车次"></el-table-column>
                <el-table-column prop="ORMTB801CA07" label="重量"> </el-table-column>
                <el-table-column prop="ORMTB801CA08" label="销售金额">
                    <template slot-scope="scope">
                        <div class="clickBtn" @click="DetailsClick(scope.row)">
                            {{ scope.row.ORMTB801CA08 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB801CA09" label="购进金额">
                    <template slot-scope="scope">
                        <div class="clickBtn" @click="DetailsClick(scope.row)">
                            {{ scope.row.ORMTB801CA09 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB801CA10" label="销售毛利">
                </el-table-column>
                <el-table-column prop="ORMTB801CA11" label="充值金额">
                    <template slot-scope="scope">
                        <div class="clickBtn" @click="reChargeDetailClick(scope.row)">{{ scope.row.ORMTB801CA11 }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB801CA12" label="调总账金额">
                    <template slot-scope="scope">
                        <div class="clickBtn" v-if="scope.row.ORMTB801CA12 == 0" @click="adjustDetailClick(scope.row)">
                            {{
                                scope.row.ORMTB801CA12 }}</div>
                        <div v-else class="clickBtn" @click="adjustDetailClick(scope.row)"
                            :class="scope.row.ORMTB801CA12 > 0 ? 'grennColor' : 'redColor'">{{ scope.row.ORMTB801CA12 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB801CA13" label="当前金额">
                </el-table-column>
                <el-table-column prop="ORMTB801CA14" label="调总账备注"></el-table-column>
                <el-table-column label="对账状态" width="200">
                    <template slot-scope="scope">
                        <el-checkbox class="custom-checkbox" v-model="scope.row.ORMTB801CA15 == 1"
                            :disabled="scope.row.ORMTB801CA15 == 1"
                            @change="(value) => handleChange(value, scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 账单明细弹窗 -->
        <div class="public-dialog">
            <el-dialog title="账单明细" :visible.sync="oerderDetilsShow" width="90%" :closeOnClickModal="false" append-to-body custom-class="account-components-detail-reconciliation-dialog">
                <div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
                    <div class="exportBtn">
                        <span style="cursor: pointer;" @click="billExport"><i class="el-icon-download"></i>导出</span>
                    </div>
                    <div class="billOperationRecord-table pulbic_table_container">
                        <el-table tooltip-effect="dark" :data="tableDataDetail" style="width: 100%;"
                            :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                                color: 'rgba(51,51,51,1)',
                                background: 'rgba(184,227,255,1)',
                                'font-weight': 'bold',
                            }" class="public_tableColumn">
                            <el-table-column prop="ORMTB440CA05" label="企业名称"></el-table-column>
                            <el-table-column prop="ORMTB440CA03" label="客户名称"></el-table-column>
                            <el-table-column prop="ORMTB440CA01" label="车牌号"> </el-table-column>
                            <el-table-column prop="ORMTB440CA07" label="订单物料"></el-table-column>
                            <el-table-column prop="ORMTB440CC02" label="完成物料"></el-table-column>
                            <el-table-column prop="ORMTB440CA10" label="派单重量">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC03" label="结算单价">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC08" label="厂家结算单价" width="150px">
                            </el-table-column>
                            <el-table-column prop="unifDiff" label="单价差额">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC04" label="结算重量">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC06" label="结算金额">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC09" label="厂家结算金额" width="150px">
                            </el-table-column>
                            <el-table-column prop="salesMargin" label="销售毛利">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC00" label="结算时间">
                            </el-table-column>
                            <el-table-column prop="ORMTB440CC07" label="结算流水号">
                            </el-table-column>
                        </el-table>
                        <div class="pulbic_pagesize">
                            <span v-if="flag == '1'" style="font-size: 14px;color:#606266;">共{{ count }}条</span>
                            <el-pagination v-if="!flag" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page.sync="currentPage"
                                :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                                layout="total,sizes, prev, pager, next, jumper" :total="count">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 充值弹窗 -->
        <div class="public-dialog">
            <el-dialog title="厂家充值" :visible.sync="rechargeShow" width="500px" :closeOnClickModal="false" append-to-body custom-class="account-components-detail-reconciliation-dialog">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="厂家" prop="factoryName">
                        <el-input v-model="ruleForm.factoryName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="accountName">
                        <el-input v-model="ruleForm.accountName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="金额" prop="ORMTB802CA05">
                        <el-input v-model="ruleForm.ORMTB802CA05" placeholder="请输入金额"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="rechargeCancleForm('ruleForm')">取消</el-button>
                        <el-button type="primary" @click="rechargeSubmitForm('ruleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <!-- 调总账弹窗 -->
        <div class="public-dialog public-dialog_adjust">
            <el-dialog title="调总账金额" :visible.sync="adjustShow" width="500px" :closeOnClickModal="false" append-to-body custom-class="account-components-detail-reconciliation-dialog">
                <el-form :model="adjustRuleForm" :rules="adjustRules" ref="adjustRuleForm" label-width="100px"
                    class="demo-ruleForm adjustForm">
                    <el-form-item label="厂家" prop="factoryName">
                        <el-input v-model="adjustRuleForm.factoryName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="accountName">
                        <el-input v-model="adjustRuleForm.accountName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="金额" prop="money">
                        <div class="symbolBox_content">
                            <div class="symbolBox">
                                <div v-for="item in symbolList" :key="item.value"
                                    :class="{ active: selectedSymbol === item.value, symbolBox_item: true }"
                                    @click="handleSymbol(item)">{{ item.label }}</div>
                            </div>
                            <el-input v-model="adjustRuleForm.money" placeholder="请输入金额"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注" prop="ORMTB802CA10">
                        <el-input type="textarea" :rows="4" v-model="adjustRuleForm.ORMTB802CA10"
                            placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between!important;">
                        <el-button @click="adjustCancleForm('adjustRuleForm')">取消</el-button>
                        <el-button type="primary" @click="adjustSubmitForm('adjustRuleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <!-- 充值明细弹窗 -->
        <div class="public-dialog">
            <el-dialog title="充值明细" :visible.sync="rechargeDetilsShow" width="60%" :closeOnClickModal="false" append-to-body custom-class="account-components-detail-reconciliation-dialog">
                <div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
                    <div class="billOperationRecord-table pulbic_table_container">
                        <el-table tooltip-effect="dark" :data="reChargeTableData" style="width: 100%;"
                            :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                                color: 'rgba(51,51,51,1)',
                                background: 'rgba(184,227,255,1)',
                                'font-weight': 'bold',
                            }" class="public_tableColumn">
                            <el-table-column prop="ORMTB802CA08" label="日期"></el-table-column>
                            <el-table-column prop="ORMTB802CA05" label="充值金额"></el-table-column>
                            <el-table-column prop="ORMTB802CA06" label="充值前金额"> </el-table-column>
                            <el-table-column prop="ORMTB802CA07" label="充值后金额"></el-table-column>
                        </el-table>
                        <div class="pulbic_pagesize">
                            <el-pagination @size-change="handleReSizeChange" @current-change="handleReCurrentChange"
                                :current-page.sync="reCurrentPage" :page-sizes="[10, 20, 30, 40]"
                                :page-size="rechargeLimitMo" layout="total,sizes, prev, pager, next, jumper"
                                :total="reChargecount">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 调总账明细 -->
        <div class="public-dialog">
            <el-dialog title="调总账明细" :visible.sync="adjustDetilsShow" width="60%" :closeOnClickModal="false" append-to-body custom-class="account-components-detail-reconciliation-dialog">
                <div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
                    <div class="billOperationRecord-table pulbic_table_container">
                        <el-table tooltip-effect="dark" :data="adjustTableData" style="width: 100%;"
                            :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                                color: 'rgba(51,51,51,1)',
                                background: 'rgba(184,227,255,1)',
                                'font-weight': 'bold',
                            }" class="public_tableColumn">
                            <el-table-column prop="ORMTB802CA08" label="日期"></el-table-column>
                            <el-table-column prop="ORMTB802CA05" label="调总账金额">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.ORMTB802CA05 == 0">{{ scope.row.ORMTB802CA05 }}</div>
                                    <div v-else :class="scope.row.ORMTB802CA05 > 0 ? 'grennColor' : 'redColor'"><span
                                            v-if="scope.row.ORMTB802CA05 > 0">+</span>{{ scope.row.ORMTB802CA05 }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ORMTB802CA06" label="调总账前金额"> </el-table-column>
                            <el-table-column prop="ORMTB802CA07" label="调总账后金额"></el-table-column>
                        </el-table>
                        <div class="pulbic_pagesize">
                            <el-pagination @size-change="handleAdjustSizeChange"
                                @current-change="handleAdjustCurrentChange" :current-page.sync="adjustCurrentPage"
                                :page-sizes="[10, 20, 30, 40]" :page-size="adjustLimitMo"
                                layout="total,sizes, prev, pager, next, jumper" :total="adjustCount">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
export default {
  mixins: [customerSearchMixin],
    name: 'DetailReconciliation',
    props: {
        mainInfo: {
            type: Object,
            default: () => { }
        },
        factoryList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            sjtxje: '',
            sjtxjenotes: '',
            ORMTB421ID: '',
            txlx: '',
            ORMTB429CA10: '',
            oerderDetilsShow: false,
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
            date: [], //日期
            // dateNowDayActive: false,
            // dateYesterdayActive: false,
            dateNowMonthActive: true,
            dateLastMonthActive: false,
            tableData: [],
            materialOptions: [],
            materialTypeValue: '',
            customerOptions: [],
            carNum: '',
            materielMo: '',
            zjr: 0,
            // 查询
            customerMo: '', //客户--查询
            ORMTB421CA14: '', //数据状态
            billOperationAdd: false,
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 审核
            imageUrl: '',
            // 详情
            billOperationDetails: false,
            detailsList: '', //详情列表
            isRefresh: true,
            isRefreshSetInterval: '',
            // quanpDisabled: false,
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',
            // 时间限制
            // 限制开始日期不能超过当前日期
            startDateDisabled: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
            },
            solelist: [],
            DetailsWaterurl: '',
            DetailsWatersrcList: [],
            detailObj: {},
            timeDate: '',
            timeframe: '',
            ORMTB803ID: '',
            ORMTB804ID: '',
            ORMTB801CA05: '',
            factoryName: '',
            accountName: '',
            tableDataDetail: [],
            count: 0,
            flag: '',
            rechargeShow: false,//充值弹窗
            adjustShow: false,//调总账弹窗
            selectedSymbol: null, // 选择的符号
            firstSum: 0,
            symbolList: [
                {
                    label: '+',
                    value: 1
                },
                {
                    label: '-',
                    value: 2
                }
            ],
            ruleForm: {
                ORMTB803ID: '',
                ORMTB804ID: '',
                ORMTB802CA05: '',
                factoryName: '',
                accountName: ''
            },
            adjustRuleForm: {
                ORMTB803ID: '',
                ORMTB804ID: '',
                money: '',
                ORMTB802CA10: '',
                factoryName: '',
                accountName: '',
                ORMTB802CA05: ''
            },
            accList: [],
            rechargeDetilsShow: false,
            reChargecount: 0,
            rechargeLimitMo: 10,
            reCurrentPage: 1,
            rePageMo: 1,
            adjustDetilsShow: false,
            adjustCount: 0,
            adjustLimitMo: 10,
            adjustCurrentPage: 1,
            adjustPageMo: 1,
            reChargeTableData: [],
            adjustTableData: [],
            rules: {
                // name: [
                //     { required: true, message: '请输入厂家', trigger: 'blur' },
                // ],
                // region: [
                //     { required: true, message: '请输入账号', trigger: 'blur' }
                // ],
                ORMTB802CA05: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value === '' || value === null || value === undefined) {
                                callback();
                                return;
                            }
                            // 检查是否为有效数字
                            if (isNaN(Number(value))) {
                                callback(new Error('金额必须为数字值'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/,
                        message: '金额最多只能有两位小数',
                        trigger: 'blur'
                    }
                ],
            },
            adjustRules: {
                money: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value === '' || value === null || value === undefined) {
                                callback();
                                return;
                            }
                            // 检查是否为有效数字
                            if (isNaN(Number(value))) {
                                callback(new Error('金额必须为数字值'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/,
                        message: '金额最多只能有两位小数',
                        trigger: 'blur'
                    }
                ],
                ORMTB802CA10: [
                    { required: true, message: '请输入备注', trigger: 'blur' },
                ]
            }
        }
    },
    created() {
        // var list = ''
        // list = this.$store.state.solelist
        // // 赋值，缓存销毁
        // this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        // sessionStorage.removeItem(this.currentUrl)
        // if (this.historyInfo != null && this.historyInfo != '') {
        //     // this.init()
        // } else {
        //     // this.getNowDay()
        // }
        // var path = this.$route.path
        // if (path === '/SalesDispatchManagement') {
        //     path = '/Home' + path
        // }
        // this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
        this.ORMTB804ID = this.mainInfo.ORMTB804ID;
        this.ORMTB803ID = this.mainInfo.ORMTB803ID;
        this.factoryName = this.mainInfo.ORMTB803CA01;
        this.accountName = this.mainInfo.ORMTB804CA01;
        this.timeframe = this.mainInfo.ORMTB803CA03;
        this.sameMonth();//设置当月
        this.getAccountList(this.ORMTB803ID);
    },
    mounted() {
        // this.enterprise0ptions()
        this.pageList();
        this.getFirstBalance();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param
            const sums = []

            columns.forEach((column, index) => {
                if (index === 0) {
                    // 第一列显示"合计"
                    sums[index] = '合计'
                    return
                }
                // 跳过不需要合计的列
                if (index === 8 || index === 9) {
                    sums[index] = ''
                    return
                }
                // 计算其他列的合计
                const values = data.map(item => {
                    const num = Number(item[column.property])
                    return isNaN(num) ? 0 : num
                })

                if (values.some(value => value !== 0)) {
                    const sum = values.reduce((acc, curr) => acc + curr, 0)
                    // 保留4位小数，去除多余的0
                    sums[index] = parseFloat(sum.toFixed(4))
                } else {
                    sums[index] = '-'
                }
            })
            return sums
        },
        adjustDetailClick(val) {
            this.adjustDetilsShow = true;
            this.adjustDetailList();
        },
        reChargeDetailClick(val) {
            this.rechargeDetilsShow = true;
            this.reDetailList();
        },
        factoryIdchange(value) {
            this.ORMTB804ID = '';
            const result = this.factoryList.filter(item => item.ORMTB803ID === value);
            const nameValue = result.length > 0 ? result[0].ORMTB803CA01 : undefined;
            const reTime = result.length > 0 ? result[0].ORMTB803CA03 : undefined;
            this.factoryName = nameValue;
            this.timeframe = reTime;
            this.getAccountList(value);
        },
        accountChange(value) {
            const aresult = this.accList.filter(item => item.ORMTB804ID === value);
            const accountValue = aresult.length > 0 ? aresult[0].ORMTB804CA01 : undefined;
            this.accountName = accountValue;
        },
        getAccountList(value) {
            this.axios.post('/orm/ormtb803/queryAccount', { ORMTB803ID: value }).then(res => {
                if (res.data.code == 200) {
                    var data = res.data.data
                    this.accList = data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                // loading.close();
            })
        },
        handleSymbol(item) {
            this.selectedSymbol = item.value;
        },
        // 充值确定
        rechargeSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    delete this.ruleForm.factoryName;
                    delete this.ruleForm.accountName;
                    const postData = {
                        ...this.ruleForm,
                        dataType: 2,
                        ORMTB802CA09: this.$store.state.uobj.pertb005.pertb005ca02
                    }
                    this.axios.post('/orm/ormtb801/rechargeOrRejulation', postData).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.rechargeShow = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    }).catch(() => {
                        // loading.close();
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 充值取消
        rechargeCancleForm(formName) {
            this.$refs[formName].resetFields();
            this.rechargeShow = false;
        },
        // 调总账确定
        adjustSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.selectedSymbol) {
                        return this.$message.warning('请选择调总账类型');
                    }
                    delete this.adjustRuleForm.factoryName;
                    delete this.adjustRuleForm.accountName;
                    if (this.selectedSymbol == 2) {
                        this.adjustRuleForm.ORMTB802CA05 = `-${this.adjustRuleForm.money}`;
                    } else {
                        this.adjustRuleForm.ORMTB802CA05 = this.adjustRuleForm.money;
                    }
                    delete this.adjustRuleForm.money;
                    const postData = {
                        ...this.adjustRuleForm,
                        dataType: 3,
                        ORMTB802CA09: this.$store.state.uobj.pertb005.pertb005ca02
                    }
                    this.axios.post('/orm/ormtb801/rechargeOrRejulation', postData).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.adjustShow = false;
                            this.pageList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    }).catch(() => {
                        // loading.close();
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 调总账取消
        adjustCancleForm(formName) {
            this.$refs[formName].resetFields();
            this.adjustShow = false;
        },
        // 充值
        handleRecharge() {
            if (!this.ORMTB804ID) {
                return this.$message.warning('请选择账户');
            }
            this.ruleForm.ORMTB802CA05 = '';
            this.rechargeShow = true;
            this.ruleForm.ORMTB803ID = this.ORMTB803ID;
            this.ruleForm.ORMTB804ID = this.ORMTB804ID;
            this.ruleForm.factoryName = this.factoryName;
            this.ruleForm.accountName = this.accountName;
        },
        // 调总账
        handleAdjust() {
            if (!this.ORMTB804ID) {
                return this.$message.warning('请选择账户');
            }
            this.adjustRuleForm = {
                ORMTB802CA05: '',
                money: '',
                ORMTB802CA10: '',
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                factoryName: this.factoryName,
                accountName: this.accountName
            };
            this.selectedSymbol = null;
            this.adjustShow = true;
        },
        // 对账状态
        handleChange(checkedStatus, row) {
            const date = new Date(row.ORMTB801CA05).getTime();
            const result = this.tableData.filter(item => item.ORMTB801CA15 == 0 && new Date(item.ORMTB801CA05).getTime() <= date);
            const timeArray = [];
            const idArray = [];
            result.forEach(item => {
                timeArray.push(item.ORMTB801CA05);
                idArray.push(item.ORMTB801ID);
            })
            const ids = idArray.join(',');
            var time = timeArray.join(',');
            if (timeArray.length > 1) {
                time = `${timeArray[0]} - ${timeArray[timeArray.length - 1]}`;
            }
            this.axios.post('/orm/ormtb801/reconciliationCheck', { ORMTB803ID: row.ORMTB803ID, ORMTB804ID: row.ORMTB804ID, ORMTB801CA05: row.ORMTB801CA05, ids: ids }).then(res => {
                if (res.data.code == 200) {
                    if (timeArray.length > 0) {
                        this.$confirm(`确定${time}数据对账校验已完成?`, '对账状态', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.setReconciliation(row, ids);//去对账
                        }).catch(() => {

                        });
                    }
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                // loading.close();
            })
        },
        setReconciliation(row, ids) {
            this.axios.post('/orm/ormtb801/reconciliation', { ORMTB803ID: row.ORMTB803ID, ORMTB804ID: row.ORMTB804ID, ORMTB801CA05: row.ORMTB801CA05, ids: ids }).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: 'success',
                        message: '对账成功'
                    });
                    this.pageList();
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                // loading.close();
            })
        },
        handleMonthChange(val) {
            const currentMonth = this.formatMonth(new Date()); // 当前月份
            const date = new Date();
            date.setMonth(date.getMonth() - 1);
            const lastMonth = this.formatMonth(date);
            if (val == currentMonth) {
                this.dateNowMonthActive = true;
                this.dateLastMonthActive = false;
            } else if (val == lastMonth) {
                this.dateLastMonthActive = true;
                this.dateNowMonthActive = false;
            } else {
                this.dateLastMonthActive = false;
                this.dateNowMonthActive = false;
            }
        },
        handleClick() {
            this.$emit('detailClick')
        },
        // 导出
        exports() {
            const ORMTB803ID = this.ORMTB803ID;
            const ORMTB804ID = this.ORMTB804ID;
            const ORMTB801CA05 = this.ORMTB801CA05;
            var url =
                this.axios.defaults.baseURL +
                '/exc/toExcel/to801Excle?ORMTB803ID=' +
                ORMTB803ID +
                '&ORMTB804ID=' +
                ORMTB804ID +
                '&ORMTB801CA05=' +
                ORMTB801CA05;
            window.location.href = url
        },
        billExport() {
            const ORMTB803ID = this.ORMTB803ID;
            const ORMTB804ID = this.ORMTB804ID;
            const ORMTB801CA05 = `${this.timeDate} 00:00:00`;
            const ORMTB803CA03 = this.timeframe;
            //  const ORMTB803ID= '10000105';   
            //     const ORMTB804ID = '20250226145253400398';
            //     const ORMTB801CA05 ='2025-11-06 00:00:00';
            //      const ORMTB803CA03 = '3-3'
            var url =
                this.axios.defaults.baseURL +
                '/exc/toExcel/to801ExcleDetail?ORMTB803ID=' +
                ORMTB803ID +
                '&ORMTB804ID=' +
                ORMTB804ID +
                '&ORMTB801CA05=' +
                ORMTB801CA05 +
                '&ORMTB803CA03=' +
                ORMTB803CA03;
            window.location.href = url
        },
        enterprise0ptions() {
            var List = [
                {
                    ORMTB421CA08: '',
                    ORMTB421CA06: '全部',
                },
            ]
            var url = '/orm/ormtb421/selectOrmtb421CA06List'
            this.axios.post(url).then(res => {
                // console.log(res)
                if (res.data.code == 200) {
                    this.customerOptions = [...List, ...res.data.data]
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        // 查询
        queryClick() {
            if (!this.ORMTB804ID) {
                return this.$message({
                    message: '请选择账户',
                    type: 'warning',
                })
            }
            this.pageList();
            this.getFirstBalance();
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            const postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                ORMTB801CA05: this.ORMTB801CA05
            }

            this.tableData = []
            const url = `/orm/ormtb801/selectList`
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data
                        this.tableData = data
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'warning',
                        })
                    }
                    loading.close()
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 月初余额
        getFirstBalance() {
            const postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                ORMTB801CA05: `${this.ORMTB801CA05}-01`,
                ORMTB803CA03: this.timeframe,
            }
            const url = `/orm/ormtb801/beginBalance`
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        this.firstSum = res.data.data;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'warning',
                        })
                    }
                    // loading.close()
                })
                .catch(() => {
                    // loading.close()
                })
        },
        // 详情
        DetailsClick(row) {
            this.oerderDetilsShow = true;
            this.timeDate = row.ORMTB801CA05;
            this.detailList();
        },
        detailList() {
            const postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                ORMTB801CA05: `${this.timeDate} 00:00:00`,
                ORMTB803CA03: this.timeframe,
                page: this.pageMo,
                limit: this.limitMo,
            }
            // const postData = {
            //     ORMTB803ID:'41010405',    
            //     ORMTB804ID:'6',
            //     ORMTB801CA05:'2025-11-10 00:00:00', 
            //     ORMTB803CA03:'8-8',
            //     page: this.pageMo,
            //     limit: this.limitMo,
            // }
            const url = `/orm/ormtb801/query440And470`
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data;
                        this.count = res.data.count;
                        this.tableDataDetail = data
                    }
                    // loading.close()
                })
                .catch(() => {
                    // loading.close()
                })
        },
        // 充值明细
        reDetailList() {
            const postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                page: this.rePageMo,
                limit: this.rechargeLimitMo,
            }
            const url = `/orm/ormtb801/queryRechargeRecord`
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.records;
                        this.reChargecount = res.data.data.total;
                        this.reChargeTableData = data;
                    }
                    // loading.close()
                })
                .catch(() => {
                    // loading.close()
                })
        },
        // 调总账明细
        adjustDetailList() {
            const postData = {
                ORMTB803ID: this.ORMTB803ID,
                ORMTB804ID: this.ORMTB804ID,
                page: this.adjustPageMo,
                limit: this.adjustLimitMo,
            }
            const url = `/orm/ormtb801/queryRejulationRecord`
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.records;
                        this.adjustCount = res.data.data.total;
                        this.adjustTableData = data;
                    }
                    // loading.close()
                })
                .catch(() => {
                    // loading.close()
                })
        },
        // 提现详情
        querydetileTX(row) {
            this.detailObj = row
        },
        //获取当月时间
        sameMonth() {
            this.ORMTB801CA05 = this.formatMonth(new Date());
            this.dateNowMonthActive = true
            this.dateLastMonthActive = false
        },
        //获取上月时间
        lastMonth() {
            const date = new Date();
            date.setMonth(date.getMonth() - 1);
            this.ORMTB801CA05 = this.formatMonth(date);
            this.dateLastMonthActive = true
            this.dateNowMonthActive = false
        },
        // 格式化月份
        formatMonth(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            return `${year}-${month}`;
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.detailList();
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.detailList();
        },
        handleReSizeChange(val) {
            this.rePageMo = 1
            this.rechargeLimitMo = val
            this.reDetailList();
        },
        // 点击页码
        handleReCurrentChange(val) {
            this.rePageMo = val
            this.reDetailList();
        },
        handleAdjustSizeChange(val) {
            this.adjustPageMo = 1
            this.adjustLimitMo = val
            this.adjustDetailList();
        },
        // 点击页码
        handleAdjustCurrentChange(val) {
            this.adjustPageMo = val
            this.adjustDetailList();
        },
    },
}
</script>

<style scoped>
.rowBox {
    padding-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
}

.pulbic_oparetionBlock {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    border: 1px solid #999;
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, 0.1);
}

.right_btn {
    float: right;
    margin-bottom: 10px;
}

.DWD-li-text {
    flex: 1;
}

.DWD-li-text input {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border: none;
    outline: none;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    border-bottom: 1px solid #999;
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.car-number-add {
    /* text-transform: uppercase; */
}

.billOperationRecord-table {
    padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
    background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

.top_btn {
    margin-left: 40px;
}


.public_operatArea_content {
    display: flex;
    width: 840px;
    justify-content: space-between;
}

.content_box {
    width: 400px;
    padding: 25px;
    box-sizing: border-box;
    background-color: #fff;
    text-align: center;
    font-size: 20px;
    border: 1px solid #f8f1f1;
    color: rgb(235, 170, 122);
    font-size: 20px;
}

/deep/.el-table .cell {
    text-align: center;
}

/deep/.el-table__footer-wrapper td {
    height: 40px;
}

.custom-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #0ebb25;
    /* 选中时的背景色 */
    border-color: #0ebb25;
    /* 选中时的边框色 */
}

.clickBtn {
    cursor: pointer;
}

.exportBtn {
    text-align: right;
}

.exportBtn>span {
    display: inline-block;
    width: 60px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ccc;
    text-align: center;
}

.demo-ruleForm /deep/.el-form-item {
    display: flex !important;
    justify-content: center !important;
}

.demo-ruleForm /deep/.el-form-item__content {
    margin-left: 0 !important;
}

.demo-ruleForm /deep/.el-form-item__label {
    width: 100px !important;
}

.demo-ruleForm /deep/.el-button+.el-button {
    margin-left: 50px;
}

.demo-ruleForm /deep/.el-textarea__inner {
    width: 300px !important;
}

.symbolBox_content {
    display: flex;
}

.symbolBox {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 10px;
}

.symbolBox_item {
    width: 16px;
    height: 16px;
    line-height: 16px;
    border: 1px solid #ccc;
    text-align: center;
    border-radius: 2px;
}

.active {
    background-color: #409eff;
    color: white;
    border-color: #409eff;
}

.public-dialog_adjust /deep/.el-dialog__body {
    display: flex;
    justify-content: center;
}

.demo-ruleForm.adjustForm {
    display: inline-block;
}

.demo-ruleForm.adjustForm /deep/.el-form-item {
    justify-content: left !important;
}

.grennColor {
    color: green;
}

.redColor {
    color: red;
}

.reconciliation-detail-page {
    min-height: 100%;
    padding: 16px;
    background: linear-gradient(180deg, #f6faff 0%, #eef5fb 100%);
    box-sizing: border-box;
}

.reconciliation-back-card,
.reconciliation-detail-filter-card,
.reconciliation-detail-table-card {
    position: relative;
    border: 1px solid rgba(217, 231, 243, .96);
    border-radius: 16px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
}

.reconciliation-detail-filter-card::after,
.reconciliation-detail-table-card::after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 3px;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(90deg, #3aa0ff, rgba(53, 199, 166, .72), transparent);
    content: '';
}

.reconciliation-back-card {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-width: 150px;
    min-height: 42px;
    margin-bottom: 12px;
    padding: 10px 18px;
    color: #51687f;
    font-weight: 700;
    cursor: pointer;
}

.reconciliation-back-card .el-icon-arrow-left {
    margin-left: 0 !important;
    color: #2689e8;
}

.reconciliation-detail-filter-card {
    padding: 16px 18px;
}

.reconciliation-detail-head,
.reconciliation-detail-table-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 14px;
    padding-top: 8px;
}

.reconciliation-detail-table-head .reconciliation-detail-desc {
    padding-right: 12px;
}

.reconciliation-detail-title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.reconciliation-detail-title::before {
    position: absolute;
    top: 2px;
    left: 0;
    width: 4px;
    height: 18px;
    border-radius: 4px;
    background: #2689e8;
    content: '';
}

.reconciliation-detail-desc {
    margin-top: 6px;
    padding-left: 12px;
    color: #7b8fa6;
    font-size: 13px;
}

.reconciliation-detail-filter-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin: 0 !important;
    padding: 0 !important;
}

.reconciliation-month-tab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 54px;
    height: 36px !important;
    margin: 0 !important;
    padding: 0 14px;
    border: 1px solid #d9e7f3;
    border-radius: 18px;
    background: #f7fbff;
    color: #51687f;
    font-weight: 700;
    line-height: 36px !important;
}

.reconciliation-month-tab:hover,
.reconciliation-month-tab.public_dateActive {
    border-color: #2689e8;
    background: #eaf5ff;
    color: #1976d2;
}

.reconciliation-month-picker,
.reconciliation-detail-field {
    display: flex;
    align-items: center;
    height: 36px;
    margin: 0 !important;
    padding: 0 !important;
}

.reconciliation-detail-page .public_optionSty {
    width: 230px;
}

.reconciliation-detail-page /deep/ .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    border-color: #d9e7f3;
    border-radius: 9px;
}

.reconciliation-query-btn {
    margin-left: auto !important;
}

.reconciliation-query-btn /deep/ .el-button,
.reconciliation-detail-actions /deep/ .el-button {
    min-width: 82px;
    height: 36px;
    padding: 0 18px;
    border: none;
    border-radius: 18px;
    font-weight: 700;
    box-shadow: 0 6px 14px rgba(38, 137, 232, .2);
}

.reconciliation-query-btn /deep/ .el-button,
.reconciliation-detail-actions /deep/ .el-button--primary {
    background: linear-gradient(135deg, #3aa0ff, #1976d2);
}

.reconciliation-detail-actions /deep/ .el-button--success {
    background: linear-gradient(135deg, #35c7a6, #10a37f);
}

.reconciliation-summary-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin: 14px 0 0 !important;
    padding: 0 !important;
}

.reconciliation-summary-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: auto;
}

.reconciliation-summary-card {
    width: 260px;
    min-height: 74px;
    padding: 16px 18px;
    border: 1px solid #e3edf7;
    border-radius: 14px;
    background: linear-gradient(135deg, #fff8f2, #ffffff);
    color: #e28a43;
    font-size: 18px;
    font-weight: 800;
    box-shadow: 0 6px 16px rgba(31, 93, 154, .06);
}

.reconciliation-summary-card-green {
    background: linear-gradient(135deg, #f0fff8, #ffffff);
}

.reconciliation-detail-actions {
    display: flex;
    gap: 10px;
    margin-left: auto !important;
}

.reconciliation-detail-table-card {
    margin-top: 14px;
    padding: 16px 18px 14px;
    overflow: visible;
}

.reconciliation-detail-table-card /deep/ .el-table {
    border: 1px solid #e3edf7;
    border-radius: 12px;
    overflow: hidden;
}

.reconciliation-detail-table-card /deep/ .el-table th {
    background: #f0f7ff !important;
    color: #24435f !important;
    font-weight: 800;
}

.reconciliation-detail-table-card /deep/ .el-table td,
.reconciliation-detail-table-card /deep/ .el-table th {
    padding: 10px 0;
    border-bottom-color: #edf3fa;
}

.reconciliation-detail-table-card /deep/ .el-table__row:hover > td {
    background: #f7fbff !important;
}

.reconciliation-detail-page .pulbic_pagesize {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
    overflow: visible;
}

@media screen and (max-width: 1180px) {
    .reconciliation-detail-page {
        padding: 12px;
    }

    .reconciliation-query-btn,
    .reconciliation-detail-actions {
        margin-left: 0 !important;
    }
}
</style>
<style>
.account-components-detail-reconciliation-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.account-components-detail-reconciliation-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.account-components-detail-reconciliation-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.account-components-detail-reconciliation-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.account-components-detail-reconciliation-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
